module.exports = __webpack_public_path__ + "media/auto_history/szkoda_istotna-76ceed15.png";